import React from "react"
import { useAnsweredFormOverviewContext } from "contexts/AnsweredFormOverviewContext"
import AnsweredFormOverviewSection from "./AnsweredFormOverviewSection"

const AnsweredFormOverviewSections = () => {
  const { sections } = useAnsweredFormOverviewContext()

  return (
    <>
      {
        sections.map((section, sectionIndex) => (
          <AnsweredFormOverviewSection
            key={section.uuid}
            isFirstSection={sectionIndex === 0}
            section={section}
          />
        ))
      }
    </>
  )
}

export default AnsweredFormOverviewSections
